type Data = Record<string, any>;

// Push custom event with dataLayer object in GTM
export const push = (event: string, data?: Data) => {
  const dataLayer = (window as any).dataLayer;
  if (dataLayer && dataLayer.push) {
    dataLayer.push({ event, ...(data || {}) });
  }
};
